<div class="drw-container">
  <div class="drw-header">
    <span class="drw-title">Your session is about to expire</span>
  </div>

  <div class="drw-content">
    <div class="drw-sub-content">
      <p class="drw-message">Do you want to extend your session time?</p>
      <p class="session-time">Session time remaining: {{ timeRemainingFormatted() }}</p>
    </div>
  </div>

  <div class="drw-footer">
    <button
      class="dialog-extend"
      mat-flat-button
      color="accent"
      (click)="extendSession()"
    >
      Extend Session
    </button>
    <button
      class="dialog-logout"
      mat-button
      (click)="logout()"
    >
      Log Out
    </button>
  </div>
</div>
